import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ProductShowcase from './components/ProductShowcase';
import IngredientsSection from './components/IngredientsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

function HomePage() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="性福寶官方網站——讓每一刻更幸福 | 天然精華配方提升活力與自信"
        description="性福寶，專為追求高品質親密生活的人群研發，採用天然精華配方，幫助提升活力與自信，讓您的每一刻都充滿幸福感。了解性福寶的核心成分、真實用戶反饋與專業使用建議，立即開啟更美好的體驗。"
        keywords="性福寶,性福寶正品購買,性福寶使用效果,性福寶成分配方,性福寶用戶評價,性福寶官方價格,性福寶適用人群"
        canonicalUrl="https://xingfubao.com/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': '性福寶官方網站——讓每一刻更幸福',
          'description': '性福寶，專為追求高品質親密生活的人群研發，採用天然精華配方，幫助提升活力與自信。',
          'url': 'https://xingfubao.com/',
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ProductShowcase />
        <IngredientsSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}

export default HomePage;